import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { withRouter } from 'next/router'
import { VehiclePartDetailContainer } from 'SRC/modules/vehicleParts/detail/components'
import { fetchVehiclePart, fetchSimilarProducts } from 'SRC/modules/vehicleParts/detail/actions'
import { Page, Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { deepCopy } from '../src/utils'

class VehiclPartPage extends React.Component {
	componentDidMount() {
		setTimeout(() => {
			window.scrollTo(0, 0)
		}, 200)

		document.addEventListener('scroll', event => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop
			const targetScrollTopInfo = 250

			const headerTopEl = document.querySelector('.vehicle-part-header-mobile__top')
			const headerTopInfoEl = document.querySelector('.vehicle-part-header-mobile__top-info')

			console.log('headerTopEl', headerTopEl)
			console.log('headerTopInfoEl', headerTopInfoEl)


			if (!headerTopEl || !headerTopInfoEl) return

			if (scrollTop >= targetScrollTopInfo) {
				headerTopInfoEl.style.opacity = 1
			} else {
				const threshold = targetScrollTopInfo * 0.6;
				if (scrollTop > threshold) {
					const adjustedScroll = scrollTop - threshold;
					const adjustedTarget = targetScrollTopInfo - threshold;
					const opacity = adjustedScroll / adjustedTarget;
					headerTopInfoEl.style.opacity = opacity;
					headerTopEl.querySelectorAll('path').forEach(svgPath => {
						svgPath.style.fill = '#000'
					});
				} else {
					headerTopInfoEl.style.opacity = 0;
					headerTopEl.querySelectorAll('path').forEach(svgPath => {
						svgPath.style.fill = '#ddd'
					});
				}
			}
		})
	}

	componentDidUpdate(prevProps) {
		if (prevProps?.router?.asPath !== this.props?.router?.asPath) {
			setTimeout(() => {
				window.scrollTo(0, 0)
			}, 200)
		}
	}

	static async getInitialProps(ctx) {
		const { store, query, req, isServer } = ctx

		console.log('VehiclPartPage query', query)

		let isPageExists = false

		const slug = query?.slug

		const locale = ctx?.locale?.toUpperCase() || query?.locale?.toUpperCase() || 'ME'

		if (slug) {
			await store.dispatch(fetchVehiclePart({ slug, locale }))

			const product = store.getState().vehicleParts.detail.item

			if (product) {
				const fields = {
					page: 1,
					limit: 4,
					locale,
					group: product?.group?.slug,
				}

				if (product?.tire_width_slug) fields.width = product?.tire_width_slug?.slug
				if (product?.tire_height_slug) fields.height = product?.tire_height_slug?.slug
				if (product?.tire_diameter_slug) fields.diameter = product?.tire_diameter_slug?.slug
				if (product?.tire_season_slug) fields.season = product?.tire_season_slug?.slug

				await store.dispatch(fetchSimilarProducts({ fields }))

				isPageExists = true
			}
		}

		const isMobileDevice = store.getState().common.isMobileDevice

		const userRequestParams = { username: 'YN483', locale }
		await store.dispatch(fetchInfo(userRequestParams))

		return {
			isPageExists,
			isMobileDevice,
			state: VehiclPartPage.getPageState(store, isPageExists)
		}
	}

	static getPageState(store, isPageExists = false) {
		const state = deepCopy(initialState)
		if (store) {
			const currentState = store.getState()

			state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
			state.user.profile.error = currentState.user.profile.error
			state.user.profile.info = currentState.user.profile.info
			state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
			state.user.profile.savedFilters = currentState.user.profile.savedFilters
			state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
			state.user.profile.packageInactiveMessage = currentState.user.profile.packageInactiveMessage
			state.user.profile.priceTypes = currentState.user.profile.priceTypes
			state.user.listSidebar = currentState.user.listSidebar
			state.user.detail.info = currentState.user.detail.info

			state.common.transitions = currentState.common.transitions
			state.common.router = currentState.common.router
			state.common.is404 = !isPageExists
			state.common.isMobileDevice = currentState.common.isMobileDevice
			state.common.userTypes = currentState.common.userTypes
			state.common.pageMetaTags = currentState.common.pageMetaTags
			state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

			state.groups.elements = currentState.groups.elements

			state.categories.currentSubcategory = currentState.categories.currentSubcategory

			if (isPageExists) {
				state.vehicleParts.detail = currentState.vehicleParts.detail
			}

			state.geoObjects.countries = currentState.geoObjects.countries
			state.geoObjects.regions = currentState.geoObjects.regions
			state.geoObjects.cities = currentState.geoObjects.cities

			state.form = currentState.form
		}
		return state
	}

	render() {
		const { isPageExists, } = this.props

		return isPageExists ? (
			<Page className='main-content main-content-full'>
					<VehiclePartDetailContainer />
			</Page>
		) : <Page404 />
	}
}

VehiclPartPage.propTypes = {
	isPageExists: PropTypes.bool.isRequired,
}

VehiclPartPage.defaultProps = {
	isPageExists: false,
}

const enhance = compose(
	withRouter,
	withTranslation
)

export default enhance(VehiclPartPage)
